import {inject, Injectable, signal} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, map, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {MatchedVccFilter, MatchedVccModel, MatchedVccResponse} from '../model/match-vcc';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class MatchingVccGridService implements GridGetService<MatchedVccResponse> {
  private readonly baseUrl = 'dbov2/connex-pay-accounting-daily-detail';
  private readonly http = inject(HttpClient);

  public readonly items = signal<MatchedVccModel[]>([]);

  getOrganizedFilters(filters?:MatchedVccFilter) {
    return {
      releasedDateFrom: filters?.releasedDateFrom? moment(filters?.releasedDateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      releasedDateTo: filters?.releasedDateTo? moment(filters?.releasedDateTo).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      tramsBookingStartDateFrom: filters?.tramsBookingStartDateFrom? moment(filters?.tramsBookingStartDateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      tramsBookingStartDateTo: filters?.tramsBookingStartDateTo? moment(filters?.tramsBookingStartDateTo).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      tramsBookingEndDateFrom: filters?.tramsBookingEndDateFrom? moment(filters?.tramsBookingEndDateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      tramsBookingEndDateTo: filters?.tramsBookingEndDateTo? moment(filters?.tramsBookingEndDateTo).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      orderNumber: filters?.orderNumber ?? '',
      tramsInvoiceNumber: filters?.tramsInvoiceNumber ?? '',
      tramsBookingNo: filters?.tramsBookingNo ?? '',
      merchantName: filters?.merchantName ?? '',
      cardLastFour: filters?.cardLastFour ?? '',
      merchantGuid: filters?.merchantGuid ?? '',
      isMapped: filters?.isMapped ?? '',
      isAmountMatches: filters?.isAmountMatches ?? '',
      isResolved: filters?.isResolved ?? '',
    }
  }

  getItems({filters, page, sort} : GridServiceParams): Observable<GridServiceResponse<MatchedVccResponse>>  {
    const params:Record<string, string | number | boolean> = {
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',

      ...this.getOrganizedFilters(filters),
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<MatchedVccResponse>>(`${this.baseUrl}`, { params: {...params} })
    .pipe(
      map(response => {
        this.items.set(response.items as any[]);
        return response;
      }),
      catchError((error:HttpErrorResponse)=>{
        throw new Error(error?.message || 'Server error');
      })
    );
  }
}
